var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProjectDifferencesView',{attrs:{"old":_vm.old,"current":_vm.current,"project-configuration":_vm.projectConfiguration,"project-configuration-loaded":_vm.projectConfigurationLoaded}})}
var staticRenderFns = []

export { render, staticRenderFns }